import Dexie from "dexie";
import db from "../Db";

var DeleteSvgByLickleunik = Dexie.async(async function* (LICLEUNIK) {
  
  yield db.open();

    await db.SVG
        .where("LICLEUNIK")
        .equals(Number(LICLEUNIK))
        .delete();
});

export default DeleteSvgByLickleunik;
